import { Component, ElementRef, OnInit, ViewChild, ViewChildren, QueryList, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { DataService } from 'src/app/shared/services/data.service';
import { IOpenTrackingOutput } from '../tracking-output.interface';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { KEYS } from 'src/app/shared/constants/keys';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MailComponent } from 'src/app/shared/components/mail/mail.component';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IPermissionWithShow } from 'src/app/shared/interface';
import * as _ from 'underscore';

@Component({
    selector: 'app-open-tracking-output',
    templateUrl: './open-tracking-output.component.html',
    styleUrls: ['./open-tracking-output.component.less'],
    standalone: false
})
export class OpenTrackingOutputComponent implements OnInit {

  sendPermission: boolean = false;

  constructor(private formBuilder:FormBuilder, private service:DataService, private elRef: ElementRef,
    private logger:NGXLogger, private activatedRoute:ActivatedRoute, private router: Router,
    private snackBar: MatSnackBar, private dialog: MatDialog,
    private permissionService: PermissionService, private utilityService: UtilityService) {}

  openTrackingForm: FormGroup;
  criteria: IOpenTrackingOutput= {};
  data: any;
  packages: number = 0;
  pallets: number = 0;
  weight: number = 0;
  cbm: number = 0;
  billDetailsDataSource = new MatTableDataSource();
  billColumns = ['billNo','cartingDate','cargo','commodityType','readyDate','invoiceNo','noOfPackages','noOfPallets','netWeight','grossWeight','cbm'];
  stuffingDetailsDataSource = new MatTableDataSource();
  stuffingColumns = ['containerNo','lineSealNo','customSealNo','sealDate','portDate'];
  forwardDetailsDataSource = new MatTableDataSource();
  forwardColumns = ['port','mode','vesselVoyage','containerNo','etd','atd','fdc','eta','ata','destuffing'];
  showVessel : boolean=false;
  showTotal : boolean=false;
  routes: any = this.activatedRoute.snapshot['_routerState'].url;
  isAfterLogin: boolean =false;
  showForwarding : boolean=false;
  forwardSize : number = 0;
  lineRouteDataSource = new MatTableDataSource();
  lineRouteColumn = ['polName','mode', 'vesselVoyage', 'etd', 'atd', 'podName', 'eta', 'ata']
  isDataFetched:boolean=false;
  isLogin:boolean=false;
  linearOutputDataSource =new MatTableDataSource<any>();
  linearOutputColumns=['blNo','billNo','cartingDate','readyDate','noOfPackages','noOfPallets','netWeight','grossWeight','cbm','commodityName'];
  showTable = false;
  linearOutputBillDetails = [];
  linearOutputStuffingDetails = [];
  linearOutputRouteDetails = [];
  LinearOutputForwardingDetails = [];

  cartingImage: any[] = [];
  stuffingImage: any[] = [];
  isCarting: boolean = true;
  shippingBillNos: { id: string, No: string, photoCount: number; videoCount: number;}[] = [];
  containerNos: { id: string, No: string, photoCount: number; videoCount: number;}[] = [];
  stuffingNos: { id: string, No: string,  photoCount: number; videoCount: number;}[] = [];
  selectedCartingBillId: string | null = null;
  filteredMedia: any[] = [];
  videoMimeTypes = {mp4: 'video/mp4', webm: 'video/webm', ogg: 'video/ogg'};
  isDeliveryType: boolean = false;
  billCartingMediaMap: { [billId: number]: any[] } = {};
  billStuffingMediaMap: { [billId: number]: any[] } = {};
  isPreviewOpen = false;
  currentMediaIndex = 0;
  mediaPreviewList: any[] = [];
  currentMedia: any = null;
  blNoRowspan: number = 1;
  shippingBillExpanded: boolean[] = [];
  containerExpanded: boolean[] = [];
  allExpanded: boolean = false;
  isAtBottom = false;

  ngOnInit(): void {
    this.isAfterLogin = this.routes.includes('/tracking-output/')
    this.getLoggedIn();
    this.initializeForm();
    this.handleQueryParams();
  }

  backToLoginPge(){
    this.router.navigate([APP_ROUTES.LOGIN]);
  }

  initializeForm(){
    this.openTrackingForm = this.formBuilder.group({
      type:['billNo', [Validators.required]],
      searchValue: ['', [Validators.required]],
      deliveryAgent:[null],
      deliveryType:[null],
      selectedShippingBill: [null],
      doorDeliveryAgent: [null],
      draftDoorDeliveryAgent: [null],
    });
  }

  getTracking(){
    this.showForwarding = false;
    this.forwardSize = 0;
    this.openTrackingForm.markAllAsTouched();
    if(this.openTrackingForm.valid){
      this.packages = 0;
      this.pallets = 0;
      this.weight = 0;
      this.cbm =0 ;
      this.criteria = {};
      this.criteria.isLoggedIn=this.isLogin;
      this.type.value === 'billNo' ? this.criteria.billNo = this.searchValue.value.trim() : 
          this.criteria.blNo = this.searchValue.value.trim();
      this.service.get(Api.OPEN_TRACKING_OUTPUT,this.criteria).subscribe(res=>{
        if(res){
          this.logger.info("Get Tracking", res);
          this.isDataFetched=true;
          this.logger.info('res ',res);
          const deliveryType = res?.deliveryType ? res.deliveryType.toUpperCase().trim() : '';
          this.isDeliveryType = ['DOOR', 'DDP', 'DDU', 'DAP'].includes(deliveryType);
          if (this.isDeliveryType) {
  if (res.isPlanConsol) {
    this.openTrackingForm.patchValue({
      doorDeliveryAgent: res.doorDeliveryAgent?.trim() || '',
      deliveryAgent: res.deliveryAgent
    });
  } else {
    this.openTrackingForm.patchValue({
      doorDeliveryAgent: res.doorDeliveryAgent?.trim() || res.deliveryAgent?.trim() || '',
      deliveryAgent: res.deliveryAgent
    });
  }
} else {
  this.openTrackingForm.patchValue({
    deliveryAgent: res.deliveryAgent,
    doorDeliveryAgent: null
  });
}
          res['isBlNo'] = this.type.value == 'blNo';
          this.data = res;
          this.getMedia(this.data);
          if (this.data?.routeDetails) {
            this.processRoutes(this.data.routeDetails);
          }
           this.openTrackingForm.patchValue({
            deliveryAgent: res.deliveryAgent,
            deliveryTpe: res.deliveryTpe,
            doorDeliveryAgent: res.cargoDoorDeliveryAgent 
          })
          this.deliveryAgent.setValue(res.deliveryAgent);
          this.showVessel = (res.vesselVoyageName !== null && res.vesselVoyageName !== 'null');
          if (this.data.onBoardDate || this.data.onBoardTime) {
            this.data['boardDateTime'] = (this.data.onBoardDate || '') + (this.data.onBoardTime ? ` (${this.data.onBoardTime})` : '');
          } else {
            this.data['boardDateTime'] = null;
          }           
          if(res?.blNo !== null && res.blNo !== 'null' && res.isBlDrafted)
          res?.billDetails.forEach(row =>{
            this.packages += Number(row.totalNoOfPkgs);
            if (row.totalNoOfPallets !== null && !isNaN(row.totalNoOfPallets)) {
                this.pallets += Number(row.totalNoOfPallets);
            }
            this.weight += Number(row.grossWeight);
            this.cbm += Number(row.cbm);
          });
          if (res?.forwardDetails?.length == 1 && res.forwardDetails[0].portId == res.forwardDetails[0].destinationId) {
            this.showForwarding = true;
          }
          this.forwardSize = res.forwardDetails.length;
          this.billDetailsDataSource = res.billDetails;
          this.stuffingDetailsDataSource = res.stuffingDetails;
          this.forwardDetailsDataSource = res.forwardDetails;
          this.lineRouteDataSource = res.routeDetails;  
          this.linearOutputDataSource = res.billDetails;
          this.linearOutputBillDetails=res.billDetails;
          this.linearOutputStuffingDetails = res.stuffingDetails;
          this.linearOutputRouteDetails = res.routeDetails;
          this.LinearOutputForwardingDetails = res.forwardDetails;
          this.blNoRowspan = res.billDetails ? res.billDetails.length : 1;

        }
      },err=> { 
        this.data = undefined;
        this.billDetailsDataSource = undefined;
        this.stuffingDetailsDataSource = undefined;
        this.forwardDetailsDataSource = undefined;
        this.lineRouteDataSource = undefined;
      });
    }
  }

  myFunction(divId: string): void {
    const element = this.elRef.nativeElement.querySelector(`#${divId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  downloadMedia(file: any): void {
    if (file.isTempStorage) {
      this.service.tempDownload(file.fileStorage).subscribe((data: any) => {
        this.triggerDownload(data);
      });
    } else {
      this.service.donwload(file.fileStorage).subscribe((data: any) => {
        this.triggerDownload(data);
      });
    }
  }

  processRoutes(routeDetails: any[]) {
    this.routes = []; 
    if (routeDetails.length > 0) {
      this.routes.push({ name: routeDetails[0].polName });
    }
    for (let i = 0; i < routeDetails.length; i++) {
      const current = routeDetails[i];
      this.routes.push({ name: current.podName });
    }
  }

  getSearchvalueErrorMessage(): string{
    return this.type?.value == 'billNo' ? '*Enter Valid Shipping bill No' : '*Enter Valid BL No'
  }

  formatWeight(weight: number): string {
    return weight % 1 === 0 ? Number(weight) + ' Kgs' : (Math.round(weight * 1000) / 1000) + ' Kgs';
  }

  getLoggedIn(){
    this.isLogin=localStorage.getItem(KEYS.ACCESS_TOKEN) ? true : false;
    if (this.isLogin) {
      const permissionsWithShowValue: IPermissionWithShow[] =
        this.permissionService.checkPermissions([PermissionKey.OPEN_TRACKING_SEND], PermissionKey.OPEN_TRACKING);
      this.sendPermission = _.findWhere(permissionsWithShowValue, { permissionCode: PermissionKey.OPEN_TRACKING_SEND })?.show ? true : false;
    }
  }
  
  @ViewChild('tableContentToCopy', { static: false }) tableContentToCopy!: ElementRef;

copyEntireTable(): void {
  if (!this.tableContentToCopy) return;

  const elementToCopy = this.tableContentToCopy.nativeElement as HTMLElement;
  const originalStates: { element: HTMLElement; originalCssText: string; originalAlign: string | null }[] = [];

  const applyLegacyCompatibleStyles = (element: HTMLElement) => {
    originalStates.push({
      element,
      originalCssText: element.style.cssText,
      originalAlign: element.getAttribute('align')
    });

    const computedStyle = window.getComputedStyle(element);

    Object.assign(element.style, {
      border: computedStyle.border,
      padding: computedStyle.padding,
      textAlign: computedStyle.textAlign,
      verticalAlign: computedStyle.verticalAlign,
      fontWeight: computedStyle.fontWeight,
      backgroundColor: computedStyle.backgroundColor,
      color: computedStyle.color,
      fontFamily: computedStyle.fontFamily,
      fontSize: computedStyle.fontSize,
      width: computedStyle.width,
      minWidth: computedStyle.minWidth,
      maxWidth: computedStyle.maxWidth,
      wordBreak: computedStyle.wordBreak,
      whiteSpace: computedStyle.whiteSpace,
      boxSizing: computedStyle.boxSizing,
    });

    if (element.tagName === 'TABLE') {
      element.setAttribute('align', 'center');
      Object.assign(element.style, {
        borderCollapse: 'collapse',
        width: 'auto',
        tableLayout: 'fixed',
      });
    }

    if (['TD', 'TH', 'TR'].includes(element.tagName)) {
      element.style.textAlign = 'left';
      element.style.verticalAlign = 'top';
    }

    if (element.classList.contains('mat-header-cell') || element.classList.contains('mat-cell')) {
      Object.assign(element.style, {
        border: '1px solid #333',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        verticalAlign: 'middle',
      });

      if (element.classList.contains('mat-header-cell')) {
        element.style.backgroundColor = computedStyle.backgroundColor || '#f9f9f9';
      }
    }

    if (element.classList.contains('bl-header-cell')) {
      element.style.backgroundColor = '#36b7f2';
      element.style.color = 'black';
    }

    if (element.classList.contains('bl-cell')) {
      element.style.backgroundColor = 'white';
    }

    if (element.classList.contains('centered-title')) {
      element.style.textAlign = 'center';
      element.style.margin = '0 auto';
      element.style.width = '100%';
      element.style.display = 'block';
    }

    Array.from(element.children).forEach(child => {
      if (child instanceof HTMLElement) applyLegacyCompatibleStyles(child);
    });
  };

  applyLegacyCompatibleStyles(elementToCopy);

  const range = document.createRange();
  range.selectNode(elementToCopy);

  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  const successful = document.execCommand('copy');
  if (successful) {
    this.snackBar.open('Table content copied to clipboard!', 'Close', { duration: 3000 });
  }
  selection?.removeAllRanges();
  originalStates.forEach(({ element, originalCssText, originalAlign }) => {
    element.style.cssText = originalCssText;
    if (originalAlign === null) {
      element.removeAttribute('align');
    } else {
      element.setAttribute('align', originalAlign);
    }
  });
}

  getMedia(data: any): void {
    this.billCartingMediaMap = {};
    this.billStuffingMediaMap = {};
    const documentPayload = this.buildPayload(data);
    const tempStoragePayload = this.buildTempStoragePayload(data);
    this.cartingImage = [];
    this.stuffingImage = [];
    const payload = this.buildPayload(data);
    this.service.post(Api.DOCUMENT_STORAGE_MULTI_MEDIA, documentPayload).subscribe(res => {
      if(res){
        this.handleCommonMediaResponse(res);
      }
    });
    if (tempStoragePayload) {
      this.service.post(Api.TEMP_STORAGE_GET_ALL, tempStoragePayload).subscribe(res => {
      if (res) {
        this.handleCommonMediaResponse(res);
      }
    });
  }
  }

  private buildPayload(data: any): any[] {
    const payload: any[] = [];
    this.shippingBillNos = [];
    this.containerNos = [];
    if (Array.isArray(data?.stuffingDetails) && data.stuffingDetails.length > 0) {
      this.containerNos = data.stuffingDetails
        .filter((container: any) => container?.containerId && container?.containerNo)
        .map((container: any) => ({ id: container.containerId, No: container.containerNo }));
    }
    if (Array.isArray(data?.billDetails) && data.billDetails.length > 0) {
      this.shippingBillNos = data.billDetails.filter((bill: any) => bill?.id && bill?.billNo)
        .map((bill: any) => ({ id: bill.id, No: bill.billNo, photoCount: 0, videoCount: 0 }));
      const shippingIds = data.billDetails
        .map((bill: any) => bill?.id)
        .filter((id: any) => id !== undefined && id !== null); 
      if (shippingIds.length > 0) {
        payload.push({
          referenceName: 'Upload Carting Bill',
          referenceIds: shippingIds
        });
      }
      const stuffingBill = data.billDetails[0];
      if (stuffingBill?.planConsolId != null && stuffingBill?.isStuffImgUploaded === true) {
        payload.push({
          referenceName: 'Upload Stuffing Img',
          referenceIds: [stuffingBill.planConsolId]
        });
      }
    }
    return payload;
  }

  private handleMediaResponse(res: any[]): void {
    this.logger.info("Media Response:", res);
    res.forEach((media: any) => {
      if (media?.fileStorage) {
      const isTempStorage = !!media?.type;
      const mediaObj = this.buildMediaObject(media, isTempStorage);
        if (media.referenceName === 'Upload Carting Bill') {
          this.cartingImage.push(mediaObj);
        } else if (media.referenceName === 'Upload Stuffing Img') {
          this.stuffingImage.push(mediaObj);
        }
      }
    });
  }

  private buildMediaObject(media: any, isTempStorage: boolean = false): any {
    const fileType = media.fileType || '';
    const fileUrl = `${isTempStorage ? Api.TEMP_STORAGE_ACTION : Api.DOCUMENT_STORAGE_ACTION}?fileName=${encodeURIComponent(media.fileStorage)}&enableLoader=false`;
      const billNo = this.shippingBillNos.find(bill => bill.id === media.referenceId)?.No;
      const stuffingBillNo = this.shippingBillNos.find(bill => bill.id === media.childId)?.No;
      const containerNo = this.stuffingNos.find(cont =>
        cont.id === media.referenceId || cont.id === media.childId)?.No;
      return { 
      id: media.id,
      referenceId: media.referenceId,
      childId: isTempStorage ?  media.referenceId : media.childId,
      url: fileUrl,
      name: media.originalFileName || 'downloaded-file',
      type: fileType.startsWith('video/') ? 'video' : 'image',
      referenceIds: media.referenceIds || [],
      fileStorage: media.fileStorage,
      billNo: billNo || stuffingBillNo || null,
      contNo: containerNo || null,
      isTempStorage: isTempStorage
    };
  }

  private populateStuffingNos(): void {
        this.stuffingNos = [...this.containerNos];
  }

  private processSelectedCartingBill(): void {
    if (this.shippingBillNos?.length > 0) {
      this.isCarting = true;
      const searchedValue = this.searchValue?.value?.trim();
      const matchedBill = this.shippingBillNos.find(bill => bill.No === searchedValue);
      if (matchedBill) {
        this.selectedCartingBillId = matchedBill.id;
        this.openTrackingForm.get('selectedShippingBill')?.setValue(matchedBill.id);
        this.filterCartingMediaByBillId();
      }
      if (this.selectedCartingBillId) {
        this.filterCartingMediaByBillId();
      }
    }
  }

  onCartingBillSelected(billId: string) {
    this.selectedCartingBillId = billId;
    this.filterCartingMediaByBillId();
  }
  
  filterCartingMediaByBillId() {
    if (!this.selectedCartingBillId) {
      this.filteredMedia = [];
      return;
    }   
    if(this.isCarting){
      this.filteredMedia = this.cartingImage.filter(media =>
        media.referenceId === Number(this.selectedCartingBillId)
      );
    }else{
      this.filteredMedia = this.stuffingImage.filter(media =>
        media.childId === Number(this.selectedCartingBillId)
      );
    }
  }
  
  onTab(isCarting: boolean){
    this.isCarting = isCarting;
    this.selectedCartingBillId = '';
    this.filteredMedia = [];
    this.openTrackingForm.get('selectedShippingBill')?.reset();
  }

  playVideo(event: Event): void {
    const video = event.target as HTMLVideoElement;
    video.play();
  }
  
  pauseVideo(event: Event): void {
    const video = event.target as HTMLVideoElement;
    video.pause();
    video.currentTime = 0;
  }

  getMimeType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    return this.videoMimeTypes[ext || ''] || 'video/mp4'; 
  }
  
  formatCBM(unit: number, isGross: boolean): string {
    if(isGross){
      return unit % 1 === 0 ? Number(unit) + ' Kgs': Math.floor(unit * 1000) / 1000 + ' Kgs';     
    }else{
      return unit % 1 === 0? Number(unit).toString(): Math.floor(unit * 1000) / 1000 + '';
    }
  }

 getEmail(): void {
  if (!this.sendPermission) {
    this.utilityService.notifier(Message.SEND_PERMISSION_WARNING, 'warning');
    return;
  }
  const form = this.openTrackingForm;
  const typeValue = form.get("type")?.value;
  const searchValue = form.get("searchValue")?.value;
  if (this.data.isBlDrafted) {
     this.data.noOfPackages = this.packages;
     this.data.noOfPallets = this.pallets;
     this.data.cbm = this.cbm;
     this.data.grossWeight = this.weight;
   }
  const dialogRef = this.dialog.open(MailComponent, {
    panelClass: 'mail-dialog-panel',
    width: '650px',
    maxWidth: '90vw',
    data: {
      ...this.data,
      isBlSearch: typeValue === 'blNo',
      ...(typeValue === 'billNo' ? { billNo: searchValue } : {})
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.logger.info("Dialog closed");
    }
  });
}


  handleQueryParams() {
  this.activatedRoute.queryParams.subscribe(params => {
    const bill = params['billNo'];
    const bl = params['blNo'];
    const searchType = params['type'] || 'shippingBill';

    if (bill || bl) {
      const typeValue = (searchType === 'blNo') ? 'blNo' : 'billNo';
      const searchValue = typeValue === 'blNo' ? bl : bill;

      this.openTrackingForm.patchValue({
        type: typeValue,
        searchValue: searchValue
      });

      setTimeout(() => {
        this.getTracking();
      }, 300);
    }
  });
}



  onShippingBillOpened(bill: any): void {
    const billId = bill.id;
    if (!this.billCartingMediaMap[billId]) {
      this.billCartingMediaMap[billId] = this.cartingImage.filter(media =>
        media.referenceId === Number(billId)
      );
    }

    if (!this.billStuffingMediaMap[billId]) {
      this.billStuffingMediaMap[billId] = this.stuffingImage.filter(media =>
        media.childId === Number(billId)
      );
    }
  }

  onStuffingPanelOpened(stuffId: string): void {
    this.selectedCartingBillId = stuffId;

    if (!this.billStuffingMediaMap[stuffId]) {
      this.billStuffingMediaMap[stuffId] = this.stuffingImage.filter(media =>
        media.childId === Number(stuffId)
      );
    }
    this.filteredMedia = this.billStuffingMediaMap[stuffId];
  }

  openPreview(file: any): void {
  const combinedMedia: any[] = [];
  const allBillIds = new Set([...Object.keys(this.billCartingMediaMap), ...Object.keys(this.billStuffingMediaMap),]);

  allBillIds.forEach(billId => {
    const carting = this.billCartingMediaMap[billId] || [];
    const stuffing = this.billStuffingMediaMap[billId] || [];
    const combined = [...carting, ...stuffing];
    combinedMedia.push(...combined);
  });

  if (this.filteredMedia) {
    combinedMedia.push(...this.filteredMedia);
  }
  this.mediaPreviewList = Array.from(
    new Map(combinedMedia.map(m => [m.fileStorage, m])).values()
  );

    this.currentMediaIndex = this.mediaPreviewList.findIndex(item => item.fileStorage === file.fileStorage);
    this.currentMedia = this.mediaPreviewList[this.currentMediaIndex];
    this.isPreviewOpen = true;
  }

  closePreview(): void {
    this.isPreviewOpen = false;
    this.currentMedia = null;
  }

  prevMedia(): void {
    if (this.currentMediaIndex > 0) {
      this.currentMediaIndex--;
    } else {
      this.currentMediaIndex = this.mediaPreviewList.length - 1;
    }
    this.currentMedia = this.mediaPreviewList[this.currentMediaIndex];
  }

  nextMedia(): void {
    if (this.currentMediaIndex < this.mediaPreviewList.length - 1) {
      this.currentMediaIndex++;
    } else {
      this.currentMediaIndex = 0;
    }
    this.currentMedia = this.mediaPreviewList[this.currentMediaIndex];
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (!this.isPreviewOpen) return;
    if (event.key === 'ArrowLeft') {
      this.prevMedia();
    } else if (event.key === 'ArrowRight') {
      this.nextMedia();
    }
  }

  //donwload images method
  downloadImage(fileName: string, fileStorage: string): void {
    const tempMedia = fileStorage?.toLowerCase().includes('api/temp-storage') ?? false;
    const url = `${ tempMedia ? Api.TEMP_STORAGE_ACTION : Api.DOCUMENT_STORAGE_ACTION}?fileName=${encodeURIComponent(fileName)}`;
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

//expand all and collapse all method
  onShippingBillToggled(index: number, expanded: boolean) {
    this.shippingBillExpanded[index] = expanded;
    this.updateGlobalExpansionState();
  }

  onContainerToggled(index: number, expanded: boolean) {
    this.containerExpanded[index] = expanded;
    this.updateGlobalExpansionState();
  }

  updateGlobalExpansionState() {
    this.allExpanded = [...this.shippingBillExpanded, ...this.containerExpanded].every(v => v);
  }

  toggleAll() {
    this.allExpanded = !this.allExpanded;
    this.shippingBillExpanded = this.shippingBillExpanded.map(() => this.allExpanded);
    this.containerExpanded = this.containerExpanded.map(() => this.allExpanded);
  }

// image and video count methods
  private populateMediaCounts(): void {
    this.shippingBillNos.forEach(bill => {
      const { photos, videos } = this.getMediaCount(bill, 'bill');
      bill.photoCount = photos;
      bill.videoCount = videos;
    });

    this.stuffingNos.forEach(container => {
      const { photos, videos } = this.getMediaCount(container, 'container');
      container.photoCount = photos;
      container.videoCount = videos;
    });
  }

  getMediaCount(item: any, type: 'bill' | 'container'): { photos: number, videos: number } {
    let photos = 0;
    let videos = 0;
    if (type === 'bill') {
      const carting = this.cartingImage?.filter(media => media.billNo === item.No) || [];
      const stuffing = this.stuffingImage?.filter(media => media.billNo === item.No) || [];

      photos += carting.filter(file => file.type === 'image').length;
      videos += carting.filter(file => file.type === 'video').length;
      photos += stuffing.filter(file => file.type === 'image').length;
      videos += stuffing.filter(file => file.type === 'video').length;

    } else if (type === 'container') {
      const stuffing = this.stuffingImage?.filter(media => media.contNo === item.No) || [];
      console.log("media logger to check container info ", this.stuffingImage);

      photos += stuffing.filter(file => file.type === 'image').length;
      videos += stuffing.filter(file => file.type === 'video').length;
    }
    return { photos, videos };
  }

  private mapBillMedia(): void {
  this.shippingBillNos.forEach(bill => {
    this.billCartingMediaMap[bill.id] = this.cartingImage.filter(media =>
      media.referenceId === Number(bill.id)
    );

    this.billStuffingMediaMap[bill.id] = this.stuffingImage.filter(media =>
      media.childId === Number(bill.id)
    );
  });
}

  private triggerDownload(data: any): void {
    if (data) {
      const url = window.URL.createObjectURL(data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.target = '_blank';
      anchor.click();
    }
  }
  
  private buildTempStoragePayload(data: any): any | null {
    const billDetails = data?.billDetails || [];
    const needsTempStorage = billDetails.some((bill: any) =>
      bill.planConsolId == null || bill.isStuffImgUploaded === null || bill.isStuffImgUploaded === false
    );
    if (needsTempStorage) {
      const billIds = billDetails.map((bill: any) => bill.id).filter((id: any) => id !== undefined && id !== null);
      return {
        billIds: billIds,
        type: 'Cargo',
        referenceName: 'Upload Stuffing Img'
      };
    }
    return null;
  }

   private handleCommonMediaResponse(res: any): void {
    if (res) {
      this.populateStuffingNos();
      this.handleMediaResponse(res);
      this.mapBillMedia();
      this.populateMediaCounts();
      this.processSelectedCartingBill();
      this.allExpanded=false;
      this.shippingBillExpanded = this.shippingBillNos.map((_, idx) => idx < 3);
      this.containerExpanded = this.stuffingNos.map(() => false);
    }
  }

@HostListener('window:scroll', [])
onWindowScroll(): void {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  this.isAtBottom = scrollTop > scrollHeight / 2;
}

handleScroll(): void {
  const target = this.isAtBottom ? 0 : document.body.scrollHeight;
  window.scrollTo({ top: target, behavior: 'smooth' });
}

  get type() { return this.openTrackingForm.get('type'); }
  get searchValue() { return this.openTrackingForm.get('searchValue'); }
  get deliveryAgent() { return this.openTrackingForm.get('deliveryAgent'); }
  get deliveryType() {return this.openTrackingForm.get('deliveryType')}
  get doorDeliveryAgent() {return this.openTrackingForm.get('doorDeliveryAgent')}
  get draftDoorDeliveryAgent() {return this.openTrackingForm.get('draftDoorDeliveryAgent')}
}
